import SquareTagsGridComponent from "./square-tags-grid-component";
import SquareTagsGridConfig from "./square-tags-grid-config";
import SquareTagsGridAdvancedConfig from "./square-tags-grid-advanced-config";

export default {
  SquareTagsGridComponent,
  SquareTagsGridConfig,
  SquareTagsGridAdvancedConfig
};
